import React from 'react'

export const MenuSeparator: React.FC = () => {
  return <hr className="menu-separator" />
}

MenuSeparator.displayName = 'MenuSeparator'
